/**
 * @generated SignedSource<<d77565a5a35ba38c677c6f97a2417350>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type NftAuctionStatus = "CANCELED" | "ENDED" | "LIVE" | "PAUSED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RegularTileContent_nftAuction$data = {
  readonly status: NftAuctionStatus | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileAuctionDetails_nftAuction">;
  readonly " $fragmentType": "RegularTileContent_nftAuction";
};
export type RegularTileContent_nftAuction$key = {
  readonly " $data"?: RegularTileContent_nftAuction$data;
  readonly " $fragmentSpreads": FragmentRefs<"RegularTileContent_nftAuction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RegularTileContent_nftAuction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileAuctionDetails_nftAuction"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "NftAuction",
  "abstractKey": null
};

(node as any).hash = "6e3635e8500556f86f51fd35d6729746";

export default node;
